<template>
  <div>
    <!--button type="button" class="btn btn-warning rounded-0 btn-sm mb-3" @click="toggleScale">
      Cambiar a escala {{ nextScale }}
    </button-->
    <div ref="chart" title="statistics chart" style="height: 450px; width: 100%"></div>
    <!--button class="btn btn-reset" :onclick="updateChart">Update Chart sample</button-->
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import {computed, onMounted, ref, watch} from "vue";
import {colorSeriesChart} from "@/utils/utils";

import router from "@/router";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";


export default {
  name: "ChartByData",
  components: {

  },

  props: {
    facetes: {
      type: Object,
      default: () => {}
    },
    facetesPivot: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {

    const { t } = useI18n();
    const route = useRoute();

    const nextScale = computed(() => isLogarithmic.value ? 'Lineal' : 'Logarítmica');
    const isLogarithmic = ref(false);
    const chart = ref(null);
    const chartOptions = ref({
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Roboto'
        },
        zoomType: 'xy'
        //height: 530
      },
      title: {
        text: ''
      },

      xAxis: {
        categories: [],
        labels: {
          rotation: 90,

        }
      },

      yAxis: {
        allowDecimals: false,
        min: 0.1,
        title: {
          text: ''
        }
      },
      plotOptions: {
        column: {
          stacking: 'normal'
        },
        series: {
          groupPadding: 0,
          cursor: 'pointer',
          point: {
            events: {
              click: (event => {
                handlePointClick(event)
              })
            }
          }

          //pointWidth: 20
        },

      },


      tooltip: {
        formatter: function () {
          return '<b>' + this.x + '</b><br/>' +
              this.series.name + ': ' + this.y + '<br/>' +
              'Total: ' + this.point.stackTotal;
        }
      },

      /*legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0
      },*/

      legend: {
        itemStyle: {
          fontWeight: 'bold',
        }
      },

      colors: [],
      series: [],
    });



    onMounted(async () => {

    });

    watch(() => props.facetes, (newFacetes, oldFacetes) => {

      // Solo ejecuta la lógica si newFacetes es diferente de oldFacetes
      if (JSON.stringify(newFacetes) !== JSON.stringify(oldFacetes)) {

        chartOptions.value.title.text = t('Activitats docents per data')
        //facet: data

        if(newFacetes.data !== undefined) {

          chartOptions.value.series = []
          chartOptions.value.xAxis.categories = []

          //console.log(newFacetes.data)
          for (let i = 0; i < newFacetes.data.length; i=i+2) {
            //console.log(newFacetes.data[i])
            chartOptions.value.xAxis.categories.push(newFacetes.data[i])
          }

          chartOptions.value.xAxis.categories.sort();
          if(chartOptions.value.xAxis.categories.length > 25){
            chartOptions.value.xAxis.categories = chartOptions.value.xAxis.categories.slice(chartOptions.value.xAxis.categories.length-25, chartOptions.value.xAxis.categories.length)
          }



          //console.log(JSON.stringify(props.facetesPivot['activitat_subtipus_docencia,data']))


          // pivot facets: subtipus,data
          //let facetPivot = props.facetesPivot['subtipus,data']

          // Unir los dos arrays
          let facetPivot = props.facetesPivot["subtipus,data"]
              //.concat(props.facetesPivot["activitat_subtipus_docencia,data"].filter(item => item.value !== "assignaturesImpartidas"))
              .concat(props.facetesPivot["activitat_subtipus_docencia,data"])
              .concat(props.facetesPivot["activitat_subtipus_formacio,data"])
              .concat(props.facetesPivot["activitat_subtipus_tutoria,data"])
              .concat(props.facetesPivot["activitat_subtipus_innovacio,data"])
              .concat(props.facetesPivot["activitat_subtipus_premis,data"])

          for (let i = 0; i < facetPivot.length; i++) {
            const typeSerie = facetPivot[i].field
            const nameSerie = facetPivot[i].value

            let pivots = facetPivot[i].pivot

            let map = new Map()
            if(pivots != null){
              for (let j = 0; j < pivots.length; j++) {
                //console.log(pivots[j].value + ": " + pivots[j].count)
                map.set(pivots[j].value, pivots[j].count)
              }
            }


            let data = []

            for (let k = 0; k < chartOptions.value.xAxis.categories.length; k++) {
              //console.log("CATEGORIA: " + chartOptions.value.xAxis.categories[k])
              if (map.get(chartOptions.value.xAxis.categories[k]) !== undefined) {
                data[k] = map.get(chartOptions.value.xAxis.categories[k])
              } else {
                data[k] = 0
              }
            }


            chartOptions.value.series.push({name: t(nameSerie), id: nameSerie, data: data, color: colorSeriesChart(nameSerie), typeSerie: typeSerie})

            //console.log(chartOptions.value.series)

            if(chartOptions.value.xAxis.categories.length <= 10){
              chartOptions.value.plotOptions.series.pointWidth = 40
            }

          }

          if (chart.value) {
            Highcharts.chart(chart.value, chartOptions.value);
          }
        }
      }





    }, { immediate: true });



    // Función para actualizar los datos del gráfico
    const updateChart = () => {

      chartOptions.value.series = [
        {
          name: 'Serie 1',
          data: [100],
        },
        {
          name: 'Serie 2',
          data: [20],
        },
        {
          name: 'Serie 3',
          data: [90],
        }
      ];

      if (chart.value) {
        Highcharts.chart(chart.value, chartOptions.value);
      }

    };


    const handlePointClick = async (event) => {
      //alert(event.point.series.name+': '+event.point.y +' - '+  event.point.category);

      //console.log("---------------- FRAN: " + event.point.series.options.typeSerie)
      // Param SUBTIPUS or ACTIVITAT_SUBTIPUS_FORMACIO, ACTIVITAT_SUBTIPUS_INNOVACIO, etc.
      let filterName = event.point.series.options.typeSerie
      //let filterValue = event.point.series.name
      let filterValue = event.point.series.userOptions.id

      let currentQuery = { ...route.query };
      // Verificar si el filtro ya existe y si tiene múltiples valores
      if (currentQuery[filterName]) {
        const existingValues = currentQuery[filterName].split(',');
        // Añadir el nuevo valor si no existe ya en la lista
        if (!existingValues.includes(filterValue)) {
          currentQuery[filterName] = [...existingValues, filterValue].join(',');
        }
      } else {
        // Si no existe, simplemente añadirlo
        currentQuery[filterName] = filterValue;
      }


      // Param DATA
      /*filterName = 'data'
      filterValue = event.point.category

      // Verificar si el filtro ya existe y si tiene múltiples valores
      if (currentQuery[filterName]) {
        const existingValues = currentQuery[filterName].split(',');
        // Añadir el nuevo valor si no existe ya en la lista
        if (!existingValues.includes(filterValue)) {
          currentQuery[filterName] = [...existingValues, filterValue].join(',');
        }
      } else {
        // Si no existe, simplemente añadirlo
        currentQuery[filterName] = filterValue;
      }*/

      await router.push({
        name: route.name,
        params: {
          page: route.params.page,
          sort: route.params.sort,
          ...(route.params.id !== undefined && { id: route.params.id }) // Añadir el parámetro 'id' solo si no es 'undefined'
        },
        query: {...currentQuery} // Mantener los parámetros actuales (modificados) de la URL
      });

      // Emitir el evento con los nuevos parámetros
      emit('apply-filter', { query: currentQuery });
      //await getMaterials(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
    };


    const toggleScale = () => {
      isLogarithmic.value = !isLogarithmic.value;
      chartOptions.value.yAxis.type = isLogarithmic.value ? 'logarithmic' : 'linear';
      Highcharts.chart(chart.value, chartOptions.value);
    };

    return {
      updateChart,
      handlePointClick,
      toggleScale,
      chartOptions,
      chart,
      nextScale
    }
  }
}
</script>
